/** Turns a stored avatar reference into something an <Image> can load. Profiles store uploaded photos as
 *  `drive-file:<id>`, which no image loader understands (native logs "No suitable image URL loader"), so each
 *  platform supplies the hook that exchanges it for a short-lived access link. Without one, only a direct
 *  http(s), data or blob URL is drawn and a stored reference falls back to initials. */
import React from 'react';

export type AvatarUrlHook = (reference?: string | null) => string | undefined;

const DIRECT_URL = /^(https?:|data:|blob:)/;

/** A reference that is already a URL, or undefined. */
export function directAvatarUrl(reference?: string | null): string | undefined {
  return reference && DIRECT_URL.test(reference) ? reference : undefined;
}

/** Providers must pass one stable hook for the life of the tree: it is called as a hook. */
export const AvatarUrlContext = React.createContext<AvatarUrlHook>(directAvatarUrl);

export function useAvatarUrl(reference?: string | null): string | undefined {
  const useResolved = React.useContext(AvatarUrlContext);
  return useResolved(reference);
}
